import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export function CopyRow({ label, value, formatted }: { label: string; value: string; formatted?: string }) {
  const { t } = useTranslation('payments');
  const [copied, setCopied] = useState(false);

  async function copy() {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1400);
    } catch {
      // ignore
    }
  }

  return (
    <div className="copy-row">
      <span className="copy-row-label">{label}</span>
      <button type="button" className="copy-row-value" onClick={() => void copy()}>
        <strong>{formatted || value}</strong>
        <span>{copied ? t('copied') : t('copy')}</span>
      </button>
    </div>
  );
}
